var locationInventoryExcludedIds = [61695230031, 41920003, 60921348175, 7396227, 66750578767];
var locationInventoryFullfillmentIds = [41920003];
var locationEmails = {};
locationEmails[35389931599] = 'amagansett@pinkchicken.com';
locationEmails[60899524687] = 'bleecker@pinkchicken.com';
locationEmails[35389767759] = 'charleston@pinkchicken.com';
locationEmails[4165730344] = 'madison@pinkchicken.com';
locationEmails[35389898831] = 'la@pinkchicken.com';
locationEmails[64290422863] = 'raleigh@pinkchicken.com';
locationEmails[69074059343] = 'westport@pinkchicken.com';
locationEmails[75358765135] = 'woodlands@pinkchicken.com';
locationEmails[68177592399] = 'tampa@pinkchicken.com';
var locationTel = {};
locationTel[35389931599] = '631-461-8270';
locationTel[60899524687] = '917-675-0056';
locationTel[35389767759] = '843-990-2238';
locationTel[4165730344] = '646-599-7217';
locationTel[35389898831] = '310-488-2157';
locationTel[64290422863] = '984-303-8729';
locationTel[69074059343] = '475-375-6612';

var allVariantsInStock = true;
document.addEventListener('inventoryInfo.appData', function(e) {
  for (let i = 0; i < window.inventoryInfo.product.variants.length; i++) {
    if(window.inventoryInfo.product.variants[i].available == false)
    {
      allVariantsInStock = false;
      break;
    }
  }
});

document.addEventListener('inventoryInfo.appRendered', function() {
  if(allVariantsInStock){
    return;
  }
  
  initBaseModal('#inventory-info-app');
  let productHandle = window.inventoryInfo.product.handle;
  let selectedVariant = null;
  let locationWithInventoryName = null;
  let numOfLocationsWithInventory = 0;
  let onlineHasInventory = false;
  

  jQuery('#location-inventory-teaser').html('');
  const inputs = document.querySelectorAll('.product__selectors .radio__buttons input:checked');
  const productInfo = document.getElementById('product_info');
  let product = null
  if (productInfo) {
    product = JSON.parse(productInfo.innerHTML).product;
  }

  let variant_title = '';
  inputs.forEach((input, index) => {
    if (index == inputs.length - 1) {
      variant_title += input.value;
    } else {
      variant_title += input.value + ' / ';
    }
  });
  
  if (product) {
    product.variants.forEach(variant => {
      if (variant_title === variant.title) {
        selectedVariant = variant.id;
      }
    });
  }
  
  for(var i = 0; i < window.inventoryInfo[productHandle].data.variantLocations.length; i++)
  {
    if(window.inventoryInfo[productHandle].data.variantLocations[i].variant == selectedVariant)
    {
      for(var j = 0; j < window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations.length; j++)
      {
        if(locationInventoryFullfillmentIds.includes(window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations[j].location.id))
        {
          if(window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations[j].quantity > 0)
          {
            onlineHasInventory = true;
          }
        }
        
        if(locationInventoryExcludedIds.includes(window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations[j].location.id))
        {
          continue;
        }

        if(window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations[j].quantity > 0)
        {
          if(!locationWithInventoryName)
          {
            locationWithInventoryName = window.inventoryInfo[productHandle].data.variantLocations[i].inventoryLocations[j].location.name;
          } 
          numOfLocationsWithInventory++;
        }
      }  
    }
  }

  if(onlineHasInventory || locationWithInventoryName)
  {
    let locationInventoryTeaserCopy = '';
    if(onlineHasInventory)
    {
      locationInventoryTeaserCopy = 'Click your out of stock size to see in store availability!';
    }
    else if(locationWithInventoryName)
    {
      locationInventoryTeaserCopy = 'In Stock at <u>' + locationWithInventoryName + '</u>';
      if(numOfLocationsWithInventory > 1)
      {
        locationInventoryTeaserCopy += ' and ' + (numOfLocationsWithInventory - 1) + ' more location';
        locationInventoryTeaserCopy += (numOfLocationsWithInventory > 2) ? 's' : '';
      }
    }
    jQuery('#location-inventory-teaser').html('<a href="#">' + locationInventoryTeaserCopy + '</a>');
    jQuery('#location-inventory-teaser a').click(function(e){
      e.preventDefault();jQuery('#inventory-info-app .iia-list-item').each(function(){
        if(jQuery(this).find('.iia-location').html().toLowerCase().includes('mochila 3pl'))
        {
          jQuery(this).remove();
        }
      });
      
      jQuery('#inventory-info-app .iia-list-item:first-child .iia-location-selector input').click();
      for (const [key, value] of Object.entries(locationEmails)) {
        if(jQuery('.iia-id-' + key).length)
        {
          jQuery('.iia-id-' + key + ' .iia-email').html('<a href="mailto:' + value + '">' + value + '</a>');
          //jQuery('.iia-id-' + key + ' .iia-phone').html('Call/Text: <a href="tel:' + locationTel[key] + '">' + locationTel[key] + '</a>');
        }
      }
      showBaseModal('#inventory-info-app');
    });
  }
});

function initBaseModal(targetModal)
{
  if(targetModal)
  {
    jQuery(targetModal).find('.close-button').click(function(){
      closeBaseModal(targetModal);
    });
  }
}

function closeBaseModal(targetModal)
{
  if(targetModal)
  {
    jQuery(targetModal).find('.base-modal, .base-modal-screen').hide();
  }
}

function showBaseModal(targetModal)
{
  if(targetModal)
  {
    jQuery(targetModal).find('.base-modal, .base-modal-screen').show();
  }
}

function locationInventoryShowOptions(locationId)
{
  if(locationEmails[locationId] && locationTel[locationId])
  {
    jQuery('#inventory-info-app .location-inventory-modal-options .btn-email').attr('href', 'mailto:' + locationEmails[locationId]);
    jQuery('#inventory-info-app .location-inventory-modal-options .btn-email').show();

    if(locationInventoryIsMobile())
    {
      jQuery('#inventory-info-app .location-inventory-modal-options .btn-phone').attr('href', 'tel:' + locationTel[locationId]);
      jQuery('#inventory-info-app .location-inventory-modal-options .btn-phone').show();
    }
    else
    {
      jQuery('#inventory-info-app .location-inventory-modal-options .btn-phone').hide();
    }
  }
  else
  {
    jQuery('#inventory-info-app .location-inventory-modal-options .btn-email').hide();
    jQuery('#inventory-info-app .location-inventory-modal-options .btn-phone').hide();
  }
}

function locationInventoryIsMobile()
{
  return navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
}